import React from 'react';
import { ColumnsType } from 'antd/es/table';
import cls from 'classnames';

import { StatusEnum } from '../../../../common/Status/index';
import { Status } from "../../../../common/Status";

import { EvaluationLabels, LearningLabels, LearningType } from '../../../../../features/reports/learning/common/interfaces';

import styles from './index.module.scss';
import { DownloadEvaluationDetails } from './DownloadEvaluationDetails';
import { ITableRecord } from './interfaces';
import { Tooltip } from 'antd';
import { CogIcon } from '../../../../common/CogIcon';
import { getTranslations } from '../../../../../features/translations/translationsUtils';

export const getHeadersToExportForCourseCompletion = (coursesNames: string[]) => {
  return [
    'Empresa', // getTranslations('REPORT_COMPANY'),
    'Correo',
    'ID',
    'Usuario', // getTranslations('REPORT_LESSON_LABEL'),
    'Condición', // getTranslations('REPORT_STATUS_OF_CONTENT', [getTranslations(LearningLabels[LearningType.lessons])]),
    'Estado de usuario', // getTranslations('REPORT_STATUS_OF_CONTENT', [getTranslations(LearningLabels[LearningType.lessons])]),
    'Grupo', // getTranslations('REPORT_NAME_OF_EVALUATION', [getTranslations(EvaluationLabels[LearningType.lessons])]),
    'Ciudad', // getTranslations('REPORT_FULFILLMENT'),
    'Pais', // getTranslations('REPORT_FULFILLMENT'),
    ...coursesNames,
  ];
};

export const getHeadersToExport = (learningType: LearningType) => {
  switch (learningType) {
    case (LearningType.lessons):
      return [
        getTranslations('REPORT_COMPANY'),
        getTranslations('REPORT_LESSON_LABEL'),
        getTranslations('REPORT_STATUS_OF_CONTENT', [getTranslations(LearningLabels[LearningType.lessons])]),
        getTranslations('REPORT_NAME_OF_EVALUATION', [getTranslations(EvaluationLabels[LearningType.lessons])]),
        getTranslations('REPORT_FULFILLMENT'),
      ];
    case (LearningType.topics):
      return [
        getTranslations('REPORT_COMPANY'),
        getTranslations('REPORT_TOPIC_LABEL'),
        getTranslations('REPORT_STATUS_OF_CONTENT', [getTranslations(LearningLabels[LearningType.topics])]),
        getTranslations('REPORT_FULFILLMENT'),
        getTranslations('REPORT_NAME_OF_EVALUATION', [getTranslations(EvaluationLabels[LearningType.topics])]),
        getTranslations('REPORT_AVERAGE_SCORE'),
      ];
    case (LearningType.courses):
      return [
        getTranslations('REPORT_COMPANY'),
        getTranslations('REPORT_COURSE_LABEL'),
        getTranslations('REPORT_STATUS_OF_CONTENT', [getTranslations(LearningLabels[LearningType.courses])]),
        getTranslations('REPORT_FULFILLMENT'),
        getTranslations('REPORT_NAME_OF_EVALUATION', [getTranslations(EvaluationLabels[LearningType.courses])]),
        getTranslations('REPORT_AVERAGE_SCORE'),
        getTranslations('REPORT_SURVEY_NAME'),
        getTranslations('REPORT_FINISHED_SURVEY'),
      ];
    default:
      return [];
  }
};
export const getRowToExport = (row: ITableRecord, learningType: LearningType) => {
  switch (learningType) {
    case (LearningType.lessons):
      return [
        row.company,
        row.contentName,
        row.status === StatusEnum.Enable ? getTranslations('LIST_ENABLED') : getTranslations('LIST_DISABLED'),
        row.evaluation,
        `${Math.round(row.fulfillment)}%`,
      ];
    case (LearningType.topics):
      return [
        row.company,
        row.contentName,
        row.status === StatusEnum.Enable ? getTranslations('LIST_ENABLED') : getTranslations('LIST_DISABLED'),
        row.fulfillment === undefined ? '' : `${Math.round(row.fulfillment)}%`,
        row.evaluation ?? '',
        row.score === undefined ? '' : `${Math.round(row.score ?? 0)}%`,
      ];
    case (LearningType.courses):
      return [
        row.company,
        row.contentName,
        row.status === StatusEnum.Enable ? getTranslations('LIST_ENABLED') : getTranslations('LIST_DISABLED'),
        row.fulfillment === undefined ? '' : `${Math.round(row.fulfillment)}%`,
        row.evaluation ?? '',
        row.score === undefined ? '' : `${Math.round(row.score ?? 0)}%`,
        row.survey ?? '',
        row.completed === undefined ? '' : `${Math.round(row.completed ?? 0)}%`,
      ];
  }
  return [];
};
export const getColumnByType = (learningType: LearningType, selectedGroupId: string | undefined) => {
  switch (learningType) {
    case (LearningType.lessons):
      return LessonsColumns(selectedGroupId);
    case (LearningType.topics):
      return TopicsColumns(selectedGroupId);
    case (LearningType.courses):
      return CoursesColumns(selectedGroupId);
  }
};
const circleFulfillment = (value: number) => {
  return <div className={cls(styles.circle, {
    [styles.green]: value >= 100,
    [styles.orange]: value < 100 && value >= 50,
    [styles.red]: value < 50,
  })}></div>
}
export const circleScore = (value: number) => {
  return <div className={cls(styles.circle, {
    [styles.green]: value >= 80,
    [styles.orange]: value < 80 && value >= 50,
    [styles.red]: value < 50,
  })}></div>
}

const renderStatus = (status: StatusEnum) => {
  return <Status status={status} />;
}

const renderFulfillment = (value?: number) => {
  if (value === undefined) {
    return null;
  }
  return <div>
    {circleFulfillment(Math.round(value))} {Math.round(value)}%
  </div>;
};

const renderFulfillmentWithDownload = (selectedGroupId: string | undefined) => (value: number | undefined, record: ITableRecord) => {
  if (value === undefined) {
    return null;
  }
  return <>
    <div>
      {circleFulfillment(Math.round(value))} {Math.round(value)}%
    </div>
    <DownloadEvaluationDetails record={record} selectedGroupId={selectedGroupId} />
  </>;
};

const renderScore = (selectedGroupId: string | undefined) => (value: number | undefined, record: ITableRecord) => {
  if (value === undefined) {
    return null
  }
  return <>
    <div>
      {circleScore(value)} {Math.round(value)}%
    </div>
    <DownloadEvaluationDetails record={record} selectedGroupId={selectedGroupId} />
  </>;
};

const renderScoreSurveyDownload = (selectedGroupId: string | undefined) => (value: number | undefined, record: ITableRecord) => {
  if (value === undefined) {
    return null
  }
  return <>
    <div>
      {circleScore(value)} {Math.round(value)}%
    </div>
    <DownloadEvaluationDetails record={record} survey selectedGroupId={selectedGroupId} />
  </>;
};
const averageScoreTitle = () => {
  return <>
    {getTranslations('REPORT_AVERAGE_SCORE')} <Tooltip
      title={<>
        {getTranslations('REPORT_GREEN_AVERAGE_SCORE')}<br />
        {getTranslations('REPORT_YELLOW_AVERAGE_SCORE')}<br />
        {getTranslations('REPORT_RED_AVERAGE_SCORE')}
      </>}
      className={styles.tooltip}
    >
      <span>
        <CogIcon size="1.4em" color="#81858b" icon={"Attention"} />
      </span>
    </Tooltip>
  </>;
}
const averageScoreSurveyTitle = () => {
  return <>
    {getTranslations('REPORT_FINISHED_SURVEY')} <Tooltip
      title={<>
        {getTranslations('REPORT_GREEN_FINISHED_SURVEY')}<br />
        {getTranslations('REPORT_YELLOW_FINISHED_SURVEY')}<br />
        {getTranslations('REPORT_RED_FINISHED_SURVEY')}
      </>}
      className={styles.tooltip}
    >
      <span>
        <CogIcon size="1.4em" color="#81858b" icon={"Attention"} />
      </span>
    </Tooltip>
  </>;
}
const fulfillmentColumnTitle = () => {
  return <>
    {getTranslations('REPORT_FULFILLMENT')} <Tooltip
      title={<>
        {getTranslations('REPORT_GREEN_FULFILLMENT')}<br />
        {getTranslations('REPORT_YELLOW_FULFILLMENT')}<br />
        {getTranslations('REPORT_RED_FULFILLMENT')}
      </>}
      className={styles.tooltip}
    >
      <span>
        <CogIcon size="1.4em" color="#81858b" icon={"Attention"} />
      </span>
    </Tooltip>
  </>;
}

const LessonsColumns: (selectedGroupId: string | undefined) => ColumnsType<ITableRecord> = (selectedGroupId: string | undefined) => [
  {
    title: getTranslations('REPORT_COMPANY'),
    dataIndex: "company",
    sortDirections: ["descend", "ascend"],
    defaultSortOrder: "ascend",
    ellipsis: true,
  },
  {
    title: getTranslations('REPORT_LESSON_LABEL'),
    dataIndex: "contentName",
    sortDirections: ["descend", "ascend"],
    defaultSortOrder: "ascend",
    ellipsis: true,
  },
  {
    title: getTranslations('REPORT_STATUS_OF_CONTENT', [getTranslations(LearningLabels[LearningType.lessons])]),
    dataIndex: "status",
    sortDirections: ["descend", "ascend"],
    defaultSortOrder: "ascend",
    ellipsis: true,
    render: renderStatus,
  },
  {
    title: getTranslations('REPORT_NAME_OF_EVALUATION', [getTranslations(EvaluationLabels[LearningType.lessons])]),
    dataIndex: "evaluation",
    sortDirections: ["descend", "ascend"],
    defaultSortOrder: "ascend",
    ellipsis: true,
  },
  {
    title: fulfillmentColumnTitle,
    dataIndex: "fulfillment",
    sortDirections: ["descend", "ascend"],
    defaultSortOrder: "ascend",
    width: 150,
    ellipsis: true,
    render: renderFulfillmentWithDownload(selectedGroupId),
  },
];

const TopicsColumns: (selectedGroupId: string | undefined) => ColumnsType<ITableRecord> = (selectedGroupId: string | undefined) => [
  {
    title: getTranslations('REPORT_COMPANY'),
    dataIndex: "company",
    sortDirections: ["descend", "ascend"],
    defaultSortOrder: "ascend",
    ellipsis: true,
  },
  {
    title: getTranslations('REPORT_TOPIC_LABEL'),
    dataIndex: "contentName",
    sortDirections: ["descend", "ascend"],
    defaultSortOrder: "ascend",
    ellipsis: true,
  },
  {
    title: getTranslations('REPORT_STATUS_OF_CONTENT', [getTranslations(LearningLabels[LearningType.topics])]),
    dataIndex: "status",
    sortDirections: ["descend", "ascend"],
    defaultSortOrder: "ascend",
    ellipsis: true,
    render: renderStatus,
  },
  {
    title: fulfillmentColumnTitle,
    dataIndex: "fulfillment",
    sortDirections: ["descend", "ascend"],
    defaultSortOrder: "ascend",
    width: 150,
    ellipsis: true,
    render: renderFulfillment
  },
  {
    title: getTranslations('REPORT_NAME_OF_EVALUATION', [getTranslations(EvaluationLabels[LearningType.topics])]),
    dataIndex: "evaluation",
    sortDirections: ["descend", "ascend"],
    defaultSortOrder: "ascend",
    ellipsis: true,
  },
  {
    title: averageScoreTitle,
    dataIndex: "score",
    sortDirections: ["descend", "ascend"],
    defaultSortOrder: "ascend",
    ellipsis: true,
    width: 210,
    render: renderScore(selectedGroupId),
  },
];

const CoursesColumns: (selectedGroupId: string | undefined) => ColumnsType<ITableRecord> = (selectedGroupId: string | undefined) => [
  {
    title: getTranslations('REPORT_COMPANY'),
    dataIndex: "company",
    sortDirections: ["descend", "ascend"],
    defaultSortOrder: "ascend",
    ellipsis: true,
    width: 200,
    fixed: true,
  },
  {
    title: getTranslations('REPORT_COURSE_LABEL'),
    dataIndex: "contentName",
    sortDirections: ["descend", "ascend"],
    defaultSortOrder: "ascend",
    ellipsis: true,
    width: 200,
    fixed: true,
  },
  {
    title: getTranslations('REPORT_STATUS_OF_CONTENT', [getTranslations(LearningLabels[LearningType.courses])]),
    dataIndex: "status",
    sortDirections: ["descend", "ascend"],
    defaultSortOrder: "ascend",
    ellipsis: true,
    render: renderStatus,
    width: 160,
  },
  {
    title: fulfillmentColumnTitle,
    dataIndex: "fulfillment",
    sortDirections: ["descend", "ascend"],
    defaultSortOrder: "ascend",
    width: 150,
    ellipsis: true,
    render: renderFulfillment,
  },
  {
    title: getTranslations('REPORT_NAME_OF_EVALUATION', [getTranslations(EvaluationLabels[LearningType.courses])]),
    dataIndex: "evaluation",
    sortDirections: ["descend", "ascend"],
    defaultSortOrder: "ascend",
    ellipsis: true,
    width: 230,
  },
  {
    title: averageScoreTitle,
    dataIndex: "score",
    sortDirections: ["descend", "ascend"],
    defaultSortOrder: "ascend",
    ellipsis: true,
    width: 210,
    render: renderScore(selectedGroupId),
  },
  {
    title: getTranslations('REPORT_SURVEY_NAME'),
    dataIndex: "survey",
    sortDirections: ["descend", "ascend"],
    defaultSortOrder: "ascend",
    ellipsis: true,
    width: 210,
  },
  {
    title: averageScoreSurveyTitle,
    dataIndex: "completed",
    sortDirections: ["descend", "ascend"],
    defaultSortOrder: "ascend",
    ellipsis: true,
    width: 210,
    render: renderScoreSurveyDownload(selectedGroupId),
  },
];